import KycCardType from './kyc-card.types';

export const setKycDetail = data =>({
    type: KycCardType.SET_KYC_CARD_DETAIL,
    payload: data
})